import { render, staticRenderFns } from "./Relatorio.vue?vue&type=template&id=f52dbc7c&scoped=true&"
import script from "./Relatorio.vue?vue&type=script&lang=js&"
export * from "./Relatorio.vue?vue&type=script&lang=js&"
import style0 from "./Relatorio.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Relatorio.vue?vue&type=style&index=1&id=f52dbc7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52dbc7c",
  null
  
)

export default component.exports